import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '../../buttons/button/button.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'mwe-chevron-nav',
  templateUrl: './chevron-nav.component.html',
  imports: [ButtonComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChevronNavComponent {
  navTitle = input<string>();
  isBackwardButtonAvailable = input<boolean>();
  titleClass = input<string>('mb-0');
  buttonSize = input<'lg' | 'md' | 'sm' | 'xs'>('sm');
  hoverBackLabelKey = input<string>('global.iconButtonDefault.back');
  hoverForwardLabelKey = input<string>('global.iconButtonDefault.forward');
  isForwardButtonAvailable = input<boolean>();
  backwardClicked = output<void>();
  forwardClicked = output<void>();
}
